import dayjs from 'dayjs'
import { Loading } from 'element-ui';


export function formatDate (date, format) {
    format = format || 'YYYY-MM-DD';
    return dayjs(date).format(format)
}

// 活动状态
export function getActivityStatus (date) {
    const dateUnix = dayjs(date).valueOf();
    const currentUnix = dayjs().valueOf();
    // 1:可报名，0: 活动结束
    if (currentUnix < dateUnix) {
        return 1
    }
    return 0
}



// type: 1:图文，2:活动，3:师资，4:空间，5：直播，6：视频，7：外链，8：慕课；9：团体
export  const toRoute = [
    '/information',
    '/activity',
    '/teacher',
    '/space',
    '/live',
    '/video',
    '',
    '/mooc',
    '/team'
]

// loding
export function loading(target, text='' ) {
    if (!target) {
      target = 'body'
    }
    return Loading.service({
      lock: true,
      text,
      spinner: 'el-icon-loading',
      target: target
    })
}